import Statement from '../components/Statement'

export default function AboutMe ({ setAboutMe }) {
  return (
    <main className='flex flex-wrap bg-white '>
      <section className='flex justify-items-end'>
        <button className='cursor-pointer ' onClick={() => setAboutMe(false)}><img src={process.env.PUBLIC_URL + 'images/black-X.png'} alt='black-X' className='w-5 h-5 m-2' /></button>
      </section>
      <section className='p-10'>
        <h1 className='font-bold'>ABOUT ME</h1>
        <Statement />
      </section>
    </main>
  )
}
